import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { inject, Injectable, Injector, TemplateRef } from '@angular/core';

import { SpinnerComponent } from '../components/spinner/spinner/spinner.component';
import { CustomOverlayRef } from './custom-overlay.ref';

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  private readonly overlay = inject(Overlay);
  private readonly injector = inject(Injector);
  private overlayRef: OverlayRef | undefined;

  public hide(): void {
    this.overlayRef?.detach();
    this.overlayRef = undefined;
  }

  public show(content?: TemplateRef<string>, data?: string): void {
    const configs = new OverlayConfig({
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
      hasBackdrop: true,
    });

    this.overlayRef = this.overlay.create(configs);
    const resolvedContent = content ?? '';
    const customOverlayRef = new CustomOverlayRef(this.overlayRef, resolvedContent, data);
    const injector = this.createInjector(customOverlayRef);

    this.overlayRef.attach(new ComponentPortal(SpinnerComponent, null, injector));
  }

  private createInjector(ref: CustomOverlayRef): Injector {
    return Injector.create({
      parent: this.injector,
      providers: [{ provide: CustomOverlayRef, useValue: ref }],
    });
  }
}
